(ns io.daskul.webapp.widgets.form.errors
  "Shared error helpers for form widgets.

   Extracted to avoid circular deps between field.cljs and lookup_create.cljs."
  (:require [clojure.string :as str]))

(defn humanize-error
  "Map raw Malli validation messages to user-friendly text."
  [error-msg]
  (when error-msg
    (condp re-find error-msg
      #"missing required key" "Required"
      #"should be a uuid"     "Invalid selection"
      #"disallowed key"       "This field cannot be modified"
      ;; Default: pass through as-is
      error-msg)))

(defn field-key->label
  "Derive a human-readable label from a field key.
   Converts :date-of-birth to \"Date Of Birth\"."
  [field-key]
  (->> (str/split (name field-key) #"-")
       (map str/capitalize)
       (str/join " ")))

(defn form-level-error-message
  "Compute error message for top of form.
   Shows count for matched field errors, lists unmatched ones specifically."
  [error schema-fields]
  (when error
    (let [field-errors (:field-errors error)]
      (if (empty? field-errors)
        (let [msg (:message error)]
          (if (= msg "Request validation failed")
            "Please check the form and try again"
            msg))
        (let [form-field-keys (set (map :name schema-fields))
              {matched true unmatched false}
              (group-by (fn [[k _]] (contains? form-field-keys k)) field-errors)
              n (count matched)
              unmatched-msgs (map (fn [[k v]]
                                    (str (field-key->label k) ": " (humanize-error v)))
                                  unmatched)]
          (str/join ". "
                    (cond-> []
                      (pos? n)
                      (conj (str "Please fix " n " error" (when (> n 1) "s") " below"))
                      (seq unmatched-msgs)
                      (into unmatched-msgs))))))))

(defn parse-error-response
  "Parse API error response into {:message ... :field-errors {...}}.
   Handles both coercion format ({:details {:field-errors ...}})
   and aggregate validation format ({:details {:name [...]}})."
  [error]
  (let [body (:response error)
        details (:details body)
        raw-errors (or (:field-errors details) details)
        field-errors (when (map? raw-errors)
                       (into {}
                         (keep (fn [[k v]]
                                 (when (keyword? k)
                                   [k (if (sequential? v) (first v) v)])))
                         raw-errors))]
    {:message (:message body)
     :field-errors (or field-errors {})}))
